module.exports = __webpack_public_path__ + "img/small_SRT406new.9c64ee6c.png";